// extracted by mini-css-extract-plugin
export var active = "_sj-1";
export var circle = "_sj-0";
export var completed = "_sj-2";
export var connector = "_sj-4";
export var connectorCompleted = "_sj-7";
export var connectorSpacer = "_sj-5";
export var iconStrokeOverride = "_sj-8";
export var labelContainer = "_sj-6";
export var pending = "_sj-3";